// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import EntityModelOutlinedSvg from "@fishx/icons-svg/es/asn/EntityModelOutlined";
import FishxIcon from '../components/FishxIcon';

var EntityModelOutlined = function EntityModelOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: EntityModelOutlinedSvg
  }));
};

EntityModelOutlined.displayName = 'EntityModelOutlined';
export default React.forwardRef(EntityModelOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/EntityModelOutlined.js
// module id = 2601
// module chunks = 0